import Vue from 'src/views/base'
import { Component, Prop } from 'vue-property-decorator'
import template from './page-tips.vue'

@Component({
    name: 'success',
    mixins: [ template ],
    components: {
    }
})
export default class PageTips extends Vue {
    @Prop({ type: String }) title
    @Prop({ type: String }) smallTips
    @Prop({ type: String }) icon
    @Prop({ type: String }) redirectUrl
    @Prop({ type: String, default: 'to' }) type
    @Prop({ type: String }) iconColor
    @Prop({ type: String }) buttonText
    @Prop({ type: Boolean, default: true }) interval
    @Prop({ type: Boolean, default: true }) isNeedButton
    @Prop({ type: String, default: true }) code

    second = 3

    defaultBtnText = '立即激活'
    redirectText = ''
    from = ''

    created() {
        this.from = this.storage.get('setting_from')
        if (this.isNeedButton) { this.handleAutomicActivation() } else  {
            this.handleAutomicTextActivation()
        }
        this.defaultBtnText = this.buttonText
    }

    handleActivation() {
        if (this.type === 'redirect') {
            this.open(this.redirectUrl)
        } else {
            this.goTo(this.redirectUrl)
        }
    }
    
    handleAutomicActivation() {
        if (!this.interval) return
        if (!this.utils.isEmpty(this.buttonText)) {
            this.defaultBtnText = this.buttonText
        }
        this.defaultBtnText = `立即激活 ${this.second}S 后自动跳转`
        let timer = setInterval(() => {
            this.second--
            this.defaultBtnText = `立即激活 ${this.second}S 后自动跳转`
            if (this.second === 0) {
                clearInterval(timer)
                this.goTo(this.redirectUrl)
            }
        }, 1000)
    }

    handleAutomicTextActivation() {
        if (!this.interval) return
        let fromText = ''
        let fromUrl = ''
        if (!this.utils.isEmpty(this.from)) {
            if (this.from === 'email') {
                fromText = '绑定邮箱'
                fromUrl = '/user/bind-email'
            } else if (this.from === 'mobile') {
                fromText = '绑定手机'
                fromUrl = '/user/bind-mobile'
            } else if (this.from === 'password') {
                fromText = '修改密码'
                fromUrl = '/user/new-password'
            }
        } else {
            fromUrl = '/user/new-password'
        }
        this.redirectText = `正在为您跳转 ${fromText} (${this.second}S)`
        let timer = setInterval(() => {
            this.second--
            this.redirectText = `正在为您跳转 ${fromText} (${this.second}S)`
            if (this.second === 0) {
                clearInterval(timer)
                this.goTo({
                    path: fromUrl,
                    query: {
                        code: this.code
                    }})
            }
        }, 1000)
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/mixins/index.js